import IndexPage from '@/views/IndexPage'

export default function Page() {
  return <IndexPage />
}
